export const BASE_URL = 'https://dog.ceo/api';
export const COUNTER_DURATION = 2000; // in milliseconds (2 seconds)
export const SET_TIMEOUT_DURATION = 7000; // in milliseconds (7 seconds)